import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { SearchService } from './search.service';
import { SearchParams } from './search-params';

@Injectable({ providedIn: 'root' })
export class SearchResolver implements Resolve<any> {
    constructor(private searchService: SearchService){

    }

   
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const param_value= route.paramMap.get('value');
        let params:SearchParams={
            tipoPaginacion:0,
            asc:false,
            busqueda:param_value
        }
        return forkJoin([
            this.searchService.searchTask(params)
        ])
    }
}